module.exports = __webpack_public_path__ + "resources/img/main05.e48380d7055e4758eb21ca651af9a20d.jpg";